export const inventoryV2 = {
	tabs: {
		storages: "Storages",
		inventories: "Inventories",
	},
	statuses: {
		open: "Open",
		in_review: "Pending approval",
		approved: "Completed",
		reopened: "Reopened",
	},
	inventoryHeader: {
		storage: "Storage",
		stockist: "Worker",
		createdAt: "Created at",
		updatedAt: "Last updated",
		reopenReasonLabel: "Rejection justification",
	},
	byStorage: {
		actions: {
			createInventory: "Take inventory",
		},
		bigNumbers: {
			total: "Inventories created",
			approved: "Inventories closed",
			open: "Open inventories",
			inReview: "Inventories to approve",
			errorMessage: "Unable to load totals.",
		},
		filters: {
			keywordPlaceholder: "Search by inventory name",
			period: "Period",
			allStatuses: "All statuses",
			categoriesPlaceholder: "Categories",
			clear: "Clear filters",
		},
		table: {
			columns: {
				status: "Status",
				name: "Inventory",
				categories: "Categories",
				worker: "Worker",
				updatedAt: "Last edit",
				actions: "Actions",
			},
			categoriesCount_one: "{{count}} category",
			categoriesCount_other: "{{count}} categories",
			rowActions: {
				view: "View",
				continue: "Continue",
				awaiting: "Awaiting",
				rejected: "Rejected",
				edit: "Edit",
				delete: "Delete",
				menu: "Open actions menu",
			},
			empty: {
				title: "No inventories for this storage",
				description: "Start an inventory to track this storage.",
				action: "Take inventory",
			},
		},
	},
	createInventoryDrawer: {
		titleCreate: "Take inventory",
		titleEdit: "Edit inventory",
		fields: {
			name: {
				label: "Inventory name",
				placeholder: "e.g. May monthly",
				requiredError: "Inform the inventory name",
				maxLengthError: "The inventory name must have at most {{maxLength}} characters",
			},
			categoriesIds: {
				label: "Categories",
				placeholder: "Select categories",
				requiredError: "Select at least one category",
			},
			storage: {
				label: "Storage",
				placeholder: "Select a storage",
				requiredError: "Select a storage",
			},
			stockistName: {
				label: "Worker",
			},
		},
		buttons: {
			cancel: "Cancel",
			create: "Start counting",
			save: "Save changes",
		},
	},
	list: {
		filters: {
			storagesPlaceholder: "All storages",
		},
		table: {
			columns: {
				storage: "Storage",
			},
			empty: {
				title: "No inventories found",
				description: "We didn't find any inventories for the storages in this place.",
			},
		},
	},
	inventoryCount: {
		header: {
			name: "Name",
			status: "Status",
			storage: "Storage",
			stockist: "Worker",
			createdAt: "Created at",
			updatedAt: "Last updated",
			editButton: "Edit",
			editApprovedTooltip: "Completed inventories cannot be edited.",
		},
		filters: {
			productNamePlaceholder: "Search product",
			categoriesPlaceholder: "All categories",
			clear: "Clear",
		},
		actions: {
			saveDraft: "Save draft",
			delete: "Delete",
			deleteApprovedTooltip: "Completed inventories cannot be deleted.",
			cancel: "Cancel",
			saveSuccess: "Draft saved.",
			saveError: "Could not save the draft.",
			deleteSuccess: "Inventory deleted.",
			deleteError: "Could not delete the inventory.",
		},
		accordion: {
			itemsSubtitle: "{{total}} items",
			counterBadge: "{{inventoried}}/{{total}} items counted",
		},
		productRow: {
			imageAlt: "Product image",
			columns: {
				product: "Product",
				count: "Count",
				newCount: "New count",
				unit: "Unit",
			},
			units: {
				milliliter: "Milliliters",
				liter: "Liters",
				kilogram: "Kilograms",
				gram: "Grams",
				unit: "Unit",
			},
			unitRemainder: {
				add: "add quantity in {{units}}",
				remove: "remove quantity in {{units}}",
				unitSuffix: "Units",
				tooltip:
					"Enter the remaining quantity (fractions) beyond the counted whole units",
			},
		},
		productRowAdmin: {
			columns: {
				systemCount: "Qty in system",
				adjustment: "Adjustment",
				loss: "Loss",
				differenceQty: "Difference in qty",
				differenceValue: "Difference in R$",
			},
		},
		submit: {
			stockist: {
				button: "Send for approval",
				dialogTitle: "Send for approval",
				dialogBody:
					"The count will be sent for approval and will await review. Do you want to continue?",
				confirm: "Send",
				cancel: "Cancel",
				success: "Inventory sent for approval.",
				error: "Could not send the inventory.",
			},
			admin: {
				button: "Complete inventory",
				dialogTitle: "Complete inventory",
				dialogBody:
					"On completion, the count will be applied to stock quantities. This action cannot be undone. Do you want to continue?",
				confirm: "Complete",
				cancel: "Cancel",
				success: "Inventory completed.",
				error: "Could not complete the inventory.",
			},
		},
		loading: "Loading...",
		error: {
			title: "Could not load inventory",
			body: "Please try again in a moment.",
			backToInventories: "Back to inventories",
		},
		permissions: {
			noAccess: "You do not have permission to view this page.",
		},
		backToStorage: "Back to storage",
		itemsHeader: "Storage items",
	},
	inventoryApproval: {
		loading: "Loading...",
		actions: {
			approve: "Approve inventory",
			reject: "Reject",
			exportPdf: "Export PDF",
		},
		bigNumbers: {
			positiveLabel: "Sum of positive differences",
			negativeLabel: "Sum of negative differences",
			productsCount_one: "{{count}} product",
			productsCount_other: "{{count}} products",
			tooltip:
				"Number of products with a difference and the total value of those differences (difference × average unit cost).",
		},
		filters: {
			productNamePlaceholder: "Search by product",
			categoriesPlaceholder: "All categories",
		},
		accordion: {
			itemsSubtitle: "{{total}} items",
			counterBadge: "{{inventoried}}/{{total}} items counted",
			inventoried: {
				title: "Counted items",
				description:
					"All items that were recounted. Flag each one as loss or adjustment to complete the inventory.",
			},
			allItems: {
				title: "All category items",
				description: "Items that did not go through the recount.",
			},
		},
		decision: {
			cancel: "Cancel",
			approve: {
				title: "Approve inventory",
				bodyPrefix: "You are approving the count of ",
				bodyHighlight_one: "{{count}} product from storage {{storage}}.",
				bodyHighlight_other: "{{count}} products from storage {{storage}}.",
				confirmQuestion: "Are you sure you want to approve?",
				confirm: "Approve",
				success: "Inventory approved.",
				error: "Could not approve the inventory.",
			},
			reject: {
				title: "Reject inventory",
				bodyPrefix: "You are rejecting the count of ",
				bodyHighlight_one: "{{count}} product from storage {{storage}}.",
				bodyHighlight_other: "{{count}} products from storage {{storage}}.",
				reasonLabel: "Justification",
				reasonPlaceholder: "Write the rejection reason",
				reasonRequired: "Inform the justification",
				reasonMaxLength: "The justification must have at most {{maxLength}} characters",
				confirm: "Reject",
				success: "Inventory rejected.",
				error: "Could not reject the inventory.",
			},
		},
		notifications: {
			persistCountError: "Could not save the count.",
			transferTypeError: "Could not update adjustment/loss.",
		},
		error: {
			title: "Failed to load the inventory",
			body: "Please try again in a moment.",
		},
		backToStorage: "Back to storage",
	},
	deleteInventoryDialog: {
		title: "Delete inventory?",
		warningMessagePrefix: "Are you sure you want to delete the inventory ",
		warningMessageSuffix: "? This action cannot be undone.",
		fallbackName: "this inventory",
		submit: "Delete inventory",
	},
};

export type InventoryV2Translations = typeof inventoryV2;
